module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/3b88fb47a568950220f29be12f681ec2.png";